export { default, getServerSideProps } from '@/views/OrgCourseDetail';
